import React, { Dispatch, FC, memo, SetStateAction } from "react";

import SearchModal from "@/components/molecules/modals/SearchModal";
import { ReservationSearchField } from "@/components/organisms/reservations/index/ReservationSearchField";
import { ReservationSearchParams } from "@/models/reservation/reservation";

interface Props {
  isOpen: boolean;
  close: () => void;
  newParams: ReservationSearchParams;
  setNewParams: Dispatch<SetStateAction<ReservationSearchParams>>;
  handleClear: () => void;
  handleSearch: () => Promise<void>;
}

const ReservationSearchModalBase: FC<Props> = ({
  isOpen,
  close,
  newParams,
  setNewParams,
  handleClear,
  handleSearch,
}) => {
  return (
    <SearchModal
      title="詳細検索"
      isOpen={isOpen}
      handleClose={close}
      handleClear={handleClear}
      handleSearch={handleSearch}
    >
      <ReservationSearchField
        newParams={newParams}
        setNewParams={setNewParams}
        handleClear={handleClear}
        handleSearch={handleSearch}
      />
    </SearchModal>
  );
};

export const ReservationSearchModal = memo(ReservationSearchModalBase);
